import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "01-auth": () => import("/vercel/path0/middleware/01.auth.ts"),
  "02-get-user": () => import("/vercel/path0/middleware/02.getUser.ts"),
  "03-auth-account": () => import("/vercel/path0/middleware/03.authAccount.ts"),
  "04-account-onboarding-guard": () => import("/vercel/path0/middleware/04.accountOnboardingGuard.ts"),
  "05-hide-in-delegate": () => import("/vercel/path0/middleware/05.hideInDelegate.ts"),
  "06-delegate-invite-token-guard": () => import("/vercel/path0/middleware/06.delegateInviteTokenGuard.ts")
}